import React, {Component} from 'react'
import PropTypes from "prop-types";
import Error from "../single_components/Error";
import Select from "react-select";
import {authenticationService} from "../../services/AuthenticationService";
import SvGraphics from "../../assets/SvGraphics";

class TargetSymptoms extends Component {

    constructor(props) {
        super(props);
        this.state = {
            symptomsArr: this.props.symptoms,
            symptoms: [],
            entry: this.props.entry,
            symptomsList: this.props.symptomsList,
        }
    }
    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    render() {
        let {symptomsArr,entry,symptomsList} = this.state

        let {t} = this.props
        let currentUser=authenticationService.currentUserValue;
        let language=localStorage.getItem('language')

        let targetText

        if(language==="he"){
            targetText=  <div className={'Symptom-Target-level-Label'}>
                <label className={'infoLabel-right'}>{t('patient_boarding.worst_symptom')}</label>
                <label className={'infoLabel-left'}>{t('patient_boarding.no_symptom')}</label>
            </div>

        }else{
            targetText=  <div className={'Symptom-Target-level-Label'}>
                <label className={'infoLabel-left'}>{t('patient_boarding.no_symptom')}</label>
                <label className={'infoLabel-right'}>{t('patient_boarding.worst_symptom')}</label>
            </div>
        }

        let symptomsListArr=[]
        if(language==="he") {
            symptomsListArr= symptomsList.map( item=>
                <option value={item.Symptom_ID} key={item.Symptom_ID}>{item.Symptom_description_he}</option>)
        }else{
            symptomsListArr= symptomsList.map( item=>
                <option value={item.Symptom_ID} key={item.Symptom_ID}>{item.Symptom_description}</option>)
        }
        let targetSymptoms=[]
        targetSymptoms = symptomsArr.map((item, index) =>
            <div className={'symptomsBlock'} key={item.Patient_symptom_index}>
                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_boarding.choose_symptom')}</label>
                        <select className={'selectBox'} id="SymptomsInputSelect" name="Symptom_ID" value={item.Symptom_ID ?item.Symptom_ID.substring(1):""}
                                onChange={event => this.props.onClickTargetSymptom(item.Symptom_ID , event.target.id, event.target.value)}>
                            <option/>
                            {symptomsListArr}
                        </select>
                    </div>

                    <div className={'inputSlots'} style={{display:item.Symptom_ID&&item.Symptom_ID.substring(1)==="51"?'block':'none'}}>
                        <label className={'infoLabel'}>{t('patient_boarding.enter_symptom')}</label>
                        <input className={'inputBoxStyle'} type="text" name="OtherSymptom" id="OtherSymptom"
                               defaultValue={item.OtherSymptom}
                               onChange={event => this.props.onClickTargetSymptom(item.Symptom_ID, event.target.id, event.target.value)}/>
                    </div>
                </div>
                <div className={'patientsFormRow'}>

                    <div className={'inputSlotsBlock-Symptoms'}>
                        <label className={'infoLabel'}>{t('patient_boarding.symptom_severity')}?</label>
                        <div className={'div-span'}>
                            <div className={'div-span-label'}>
                                <span className="levelSymptom" id="levelSymptomLine0"
                                      style={{background: item.Symptom_rating === "levelSymptomLine0" ?'#005f7f': '#ffffff',
                                          color: item.Symptom_rating === "levelSymptomLine0" ?'#ffffff': '#1d1d1b' }}
                                      onClick={event => this.props.onClickTargetSymptom(item.Symptom_ID ,event.target.id , event.target.id)}
                                >0</span>
                                <span className="tooltiptext">{t('patient_boarding.symptom_severity0')}</span>

                            </div>

                            <span className="levelSymptomLine"/>

                            <div className={'div-span-label'}>
                                <span className="levelSymptom" id="levelSymptomLine1"
                                      style={{background: item.Symptom_rating === "levelSymptomLine1" ?'#005f7f': '#ffffff' ,
                                          color: item.Symptom_rating === "levelSymptomLine1" ?'#ffffff': '#1d1d1b' }}
                                      onClick={event => this.props.onClickTargetSymptom(item.Symptom_ID,event.target.id,event.target.id)}
                                >1</span>
                                <span className="tooltiptext">{t('patient_boarding.symptom_severity1')}</span>

                            </div>
                            <span className="levelSymptomLine"/>


                            <div className={'div-span-label'}>
                                <span className="levelSymptom" id="levelSymptomLine2"
                                      style={{background: item.Symptom_rating === "levelSymptomLine2" ?'#005f7f': '#ffffff' ,
                                          color: item.Symptom_rating === "levelSymptomLine2" ?'#ffffff': '#1d1d1b' }}
                                      onClick={event => this.props.onClickTargetSymptom(item.Symptom_ID,event.target.id,event.target.id)}
                                >2</span>
                                <span className="tooltiptext">{t('patient_boarding.symptom_severity2')}</span>

                            </div>
                            <span className="levelSymptomLine"/>


                            <div className={'div-span-label'}>
                                <span className="levelSymptom" id="levelSymptomLine3"
                                      style={{background: item.Symptom_rating === "levelSymptomLine3" ?'#005f7f': '#ffffff' ,
                                          color: item.Symptom_rating === "levelSymptomLine3" ?'#ffffff': '#1d1d1b' }}
                                      onClick={event => this.props.onClickTargetSymptom(item.Symptom_ID,event.target.id,event.target.id)}
                                >3</span>
                                <span className="tooltiptext">{t('patient_boarding.symptom_severity3')}</span>

                            </div>
                            <span className="levelSymptomLine"/>


                            <div className={'div-span-label'}>
                                <span className="levelSymptom" id="levelSymptomLine4"
                                      style={{background: item.Symptom_rating === "levelSymptomLine4" ?'#005f7f': '#ffffff',
                                          color: item.Symptom_rating === "levelSymptomLine4" ?'#ffffff': '#1d1d1b' }}
                                      onClick={event => this.props.onClickTargetSymptom(item.Symptom_ID,event.target.id,event.target.id)}>4</span>
                                <span className="tooltiptext">{t('patient_boarding.symptom_severity4')}</span>

                            </div>
                            <span className="levelSymptomLine"/>


                            <div className={'div-span-label'}>
                                <span className="levelSymptom" id="levelSymptomLine5"
                                      style={{background: item.Symptom_rating === "levelSymptomLine5" ?'#005f7f': '#ffffff' ,
                                          color: item.Symptom_rating === "levelSymptomLine5" ?'#ffffff': '#1d1d1b' }}
                                      onClick={event => this.props.onClickTargetSymptom(item.Symptom_ID,event.target.id,event.target.id)}>5</span>
                                <span className="tooltiptext">{t('patient_boarding.symptom_severity5')}</span>

                            </div>
                            <span className="levelSymptomLine"/>


                            <div className={'div-span-label'}>
                                <span className="levelSymptom" id="levelSymptomLine6"
                                      style={{background: item.Symptom_rating === "levelSymptomLine6" ?'#005f7f': '#ffffff' ,
                                          color: item.Symptom_rating === "levelSymptomLine6" ?'#ffffff': '#1d1d1b' }}
                                      onClick={event => this.props.onClickTargetSymptom(item.Symptom_ID,event.target.id,event.target.id)}>6</span>
                                <span className="tooltiptext">{t('patient_boarding.symptom_severity6')}</span>

                            </div>
                            <span className="levelSymptomLine"/>


                            <div className={'div-span-label'}>
                                <span className="levelSymptom" id="levelSymptomLine7"
                                      style={{background: item.Symptom_rating === "levelSymptomLine7" ?'#005f7f': '#ffffff' ,
                                          color: item.Symptom_rating === "levelSymptomLine7" ?'#ffffff': '#1d1d1b' }}
                                      onClick={event => this.props.onClickTargetSymptom(item.Symptom_ID,event.target.id,event.target.id)}>7</span>
                                <span className="tooltiptext">{t('patient_boarding.symptom_severity7')}</span>

                            </div>
                            <span className="levelSymptomLine"/>


                            <div className={'div-span-label'}>
                                <span className="levelSymptom" id="levelSymptomLine8"
                                      style={{background: item.Symptom_rating === "levelSymptomLine8" ?'#005f7f': '#ffffff' ,
                                          color: item.Symptom_rating === "levelSymptomLine8" ?'#ffffff': '#1d1d1b' }}
                                      onClick={event => this.props.onClickTargetSymptom(item.Symptom_ID,event.target.id,event.target.id)}>8</span>
                                <span className="tooltiptext">{t('patient_boarding.symptom_severity8')}</span>

                            </div>
                            <span className="levelSymptomLine"/>


                            <div className={'div-span-label'}>
                                <span className="levelSymptom" id="levelSymptomLine9"
                                      style={{background: item.Symptom_rating === "levelSymptomLine9" ?'#005f7f': '#ffffff' ,
                                          color: item.Symptom_rating === "levelSymptomLine9" ?'#ffffff': '#1d1d1b' }}
                                      onClick={event => this.props.onClickTargetSymptom(item.Symptom_ID,event.target.id,event.target.id)}>9</span>
                                <span className="tooltiptext">{t('patient_boarding.symptom_severity9')}</span>

                            </div>
                            <span className="levelSymptomLine"/>

                            <div className={'div-span-label'}>
                                <span className="levelSymptom" id="levelSymptomLine10"
                                      style={{background: item.Symptom_rating === "levelSymptomLine10" ?'#005f7f': '#ffffff',
                                          color: item.Symptom_rating === "levelSymptomLine10" ?'#ffffff': '#1d1d1b' }}
                                      onClick={event => this.props.onClickTargetSymptom(item.Symptom_ID,event.target.id,event.target.id)}>10</span>
                                <span className="tooltiptext">{t('patient_boarding.symptom_severity10')}</span>
                            </div>


                        </div>
                        {targetText}
                    </div>


                    <div className={'inputSlotsBlock'}>
                        <label className={'infoLabel'}>{t('patient_boarding.Suffer_duration')}</label>
                        <select className={'selectBox'} id="Suffer_duration" name="Suffer_duration" value={item.Suffer_duration}
                                onChange={event => this.props.onClickTargetSymptom(item.Symptom_ID , event.target.id, event.target.value)}>
                            <option/>
                            <option value="0">{t('patient_boarding.-1Months')}</option>
                            <option value="1-3">{t('patient_boarding.1_3M')}</option>
                            <option value="3-6">{t('patient_boarding.3_6M')}</option>
                            <option value="6-12">{t('patient_boarding.6_12M')}</option>
                            <option value="1+">{t('patient_boarding.1+Y')}</option>
                        </select>
                    </div>

                    <div className={'checkbox-label-target-symtoms'}>
                        <input type={"checkbox"} className={"checkboxStyle"} id="Symptom_is_primary" name="Symptom_is_primary"
                               checked={item.Symptom_is_primary} disabled={!item.Symptom_ID}
                               onChange={event => this.props.onClickTargetSymptom(item.Symptom_ID ,event.target.id, event.target.value)}/>
                               <label className={'infoLabel-small'}>{t('patient_boarding.set_primary')}</label>
                        <div class={'delete-icon-div'}>
                            <SvGraphics className={"delete-icon"}
                                        onClick={() => this.props.addDeleteTargetSymptom(item)} svgname={'delete-icon'}/>
                        </div>

                    </div>
                </div>
                <div className={'patientsFormRow2'}>
                </div>

            </div>
        )

        return (
            <div className={'patientsFormBoxes'}>
                {targetSymptoms}

                <div className={'svg-label'} onClick={() => this.props.addDeleteTargetSymptom("Add")}>
                    <SvGraphics className={"delete-icon"} svgname={'add-icon'}/>
                    <div className={'addTarget'} >{t('patient_boarding.add_symptom')}</div>
                </div>
            </div>
        )
    }
}

TargetSymptoms.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default TargetSymptoms;
